import { createBrowserRouter } from 'react-router-dom';
import Dashboard from '../pages/dashboard/Dashboard';
import ErrorPage from '../pages/common/ErrorPage';
import Login from '../pages/login/Login';
import App from '../App';
import AuthRoute from './authRoute';
import GetStarted from '../pages/get-started/GetStarted';
import OrganizationList from '../pages/organization-list/list/Organization';
import AdminStaff from '../pages/staff/list/Staff';
import AdminRole from '../pages/staff/roles/Role';
import AdminPermission from '../pages/staff/permission/Permission';
import RedirectPage from '../pages/common/RedirectPage';
import RegisterAccount from '../pages/register-account/RegisterAccount';
import ForgotPassword from '../pages/forgot-password/ForgotPassword';
import ResetPassword from '../pages/reset-password/ResetPassword';
import Profile from '../pages/profile/Profile';
import SetNewPassword from '../pages/set-new-password/SetNewPassword';
import Report from '../pages/report/Report';
import Subscriptions from '../pages/subscriptions/Subscriptions';
import FeaturesManagement from '../pages/subscriptions/features-management/FeaturesManagement';
import Help from '../pages/help/Help';
import OrgDashboard from '../pages/organization/org-dashboard/OrgDashboard';
import OrgProfile from '../pages/organization/org-profile/OrgProfile';
import VenueListManagement from '../pages/organization/venue/venue-list/VenueListManagement';
import OrgStaff from '../pages/organization/org-staff/org-staff-list/OrgStaff';
import OrgStaffPermission from '../pages/organization/org-staff/org-staff-permission/OrgStaffPermission';
import OrgSubscriptions from '../pages/organization/org-subscriptions/OrgSubscriptions';
import OrgReport from '../pages/organization/org-report/OrgReport';
import OrgHelp from '../pages/organization/org-help/OrgHelp';
import PageUnderConstruction from '../pages/organization/venue/PageUnderConstruction';
import VenuePermission from '../pages/organization/venue/venue-permissions/VenuePermission';
import VenueUsers from '../pages/organization/venue/venue-users/VenueUsers';
import VenueMenuManagement from '../pages/organization/venue/venue-menu/VenueMenuManagement';
import BulkUpload from '../pages/organization/venue/venue-menu/bulk-upload/BulkUpload';
import VenueSettingsManagement from '../pages/organization/venue/venue-settings/VenueSettingsManagement';
import VenueScheduleManagement from '../pages/organization/venue/venue-schedule/VenueScheduleManagement';
import OrgSettings from '../pages/organization/org-settings/OrgSettings';
import Settings from '../pages/settings/Settings';

export const browserRouter = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: '/',
                element: <AuthRoute />,
                errorElement: <ErrorPage />,
            },
            {
                path: '/admin',
                element: <AuthRoute />,
                errorElement: <ErrorPage />,
                children: [
                    {
                        path: 'dashboard',
                        element: <Dashboard />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'profile',
                        element: <Profile />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'organization/list',
                        element: <OrganizationList />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'staff',
                        errorElement: <ErrorPage />,
                        children: [
                            {
                                path: 'list',
                                element: <AdminStaff />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'roles',
                                element: <AdminRole />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'permissions',
                                element: <AdminPermission />,
                                errorElement: <ErrorPage />,
                            },
                        ],
                    },
                    {
                        path: 'settings',
                        element: <Settings />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'subscriptions',
                        // element: <Subscriptions />,
                        errorElement: <ErrorPage />,
                        children: [
                            {
                                path: 'plans',
                                element: <Subscriptions />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'features',
                                element: <FeaturesManagement />,
                                errorElement: <ErrorPage />,
                            },
                        ],
                    },
                    {
                        path: 'report',
                        element: <Report />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'help',
                        element: <Help />,
                        errorElement: <ErrorPage />,
                    },
                ],
            },
            {
                path: '/organization',
                element: <AuthRoute />,
                errorElement: <ErrorPage />,
                children: [
                    {
                        path: 'dashboard',
                        element: <OrgDashboard />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'profile',
                        element: <OrgProfile />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'venue',
                        errorElement: <ErrorPage />,
                        children: [
                            {
                                path: 'list',
                                element: <VenueListManagement />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'users',
                                element: <VenueUsers />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'roles',
                                element: <PageUnderConstruction />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'permissions',
                                element: <VenuePermission />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'fbmenu',
                                element: <VenueMenuManagement />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'fbmenu/bulk-upload',
                                element: <BulkUpload />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'schedules',
                                element: <VenueScheduleManagement />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'settings',
                                element: <VenueSettingsManagement />,
                                errorElement: <ErrorPage />,
                            },
                        ],
                    },
                    {
                        path: 'staff',
                        errorElement: <ErrorPage />,
                        children: [
                            {
                                path: 'list',
                                element: <OrgStaff />,
                                errorElement: <ErrorPage />,
                            },
                            {
                                path: 'permissions',
                                element: <OrgStaffPermission />,
                                errorElement: <ErrorPage />,
                            },
                        ],
                    },
                    {
                        path: 'settings',
                        element: <OrgSettings />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'subscriptions',
                        element: <OrgSubscriptions />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'report',
                        element: <OrgReport />,
                        errorElement: <ErrorPage />,
                    },
                    {
                        path: 'help',
                        element: <OrgHelp />,
                        errorElement: <ErrorPage />,
                    },
                ],
            },
            {
                path: '/get-started',
                errorElement: <ErrorPage />,
                children: [
                    {
                        path: 'create-venue/:step',
                        element: <GetStarted />,
                        errorElement: <ErrorPage />,
                    },
                ],
            },
            {
                path: '/login',
                element: <Login />,
                errorElement: <ErrorPage />,
            },
            {
                path: '/forgot-password',
                element: <ForgotPassword />,
                errorElement: <ErrorPage />,
            },
            {
                path: '/reset-password',
                element: <ResetPassword />,
                errorElement: <ErrorPage />,
            },
            {
                path: '/set-new-password',
                element: <SetNewPassword />,
                errorElement: <ErrorPage />,
            },
            {
                path: '*',
                element: <Login />, // re-direct to login, in case of in-valid URL
            },
            {
                path: '/rp/:shortCode',
                element: <RedirectPage />,
            },
            {
                path: '/register-account/',
                element: <RegisterAccount />,
            },
        ],
    },
]);

export const routes = {
    login: '/login',
    forgotPassword: '/forgot-password',

    // admin staff routes
    dashboard: '/admin/dashboard',
    orgManagement: '/org-management',
    venueManagement: '/venue-management',
    userManagement: '/user-management',
    permissions: '/permissions',
    subscriptions: '/admin/subscriptions',
    report: '/admin/report',
    help: '/admin/help',
    onBoardCreateVenue: '/get-started/create-venue/',
    profile: '/admin/profile',
    organizationList: '/admin/organization/list',
    staff: '/admin/staff',
    settings: '/admin/settings',

    // org-admin staff routes
    orgDashboard: '/organization/dashboard',
    orgVenue: '/organization/venue',
    orgVenueFbMenu: '/organization/venue/fbmenu',
    orgVenueBulkUpload: '/organization/venue/fbmenu/bulk-upload',
    orgStaff: '/organization/staff',
    orgSettings: '/organization/settings',
    orgSubscriptions: '/organization/subscriptions',
    orgReport: '/organization/report',
    orgHelp: '/organization/help',
    orgProfile: '/organization/profile',
};
